/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_Bucket_60_90Inputs */

const vi_report_debt_bucket_60_90 = /** @type {(inputs: Report_Debt_Bucket_60_90Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 - 90 ngày`)
};

/**

* @param {Report_Debt_Bucket_60_90Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_bucket_60_90 = /** @type {((inputs?: Report_Debt_Bucket_60_90Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_Bucket_60_90Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_bucket_60_90(inputs)
});